export default function Header() {
    return (
        <>
            <header id="header">
                <div className="container-1400">
                    <div className="header__wrap">
                        <div className="logo">
                            <a href="/">
                                <img src="../img/logo.png" alt="(주)에이스펙" />
                            </a>
                        </div>

                        <a className="mmenu"><span></span></a>
                    </div>
                </div>

                <div className="gnb__mo">
                    <div className="logo__mo">
                        <img src="../img/logo-wh.png" alt="(주)에이스펙" />
                    </div>

                    <ul className="">
                        <li>
                            <a href="/introduce/summary"><span>회사소개</span></a>
                            <div className="depth__mo">
                                <ul className="">
                                    <li><a href="/introduce/summary"><span>회사개요</span></a></li>
                                    <li><a href="/introduce/factory"><span>공장소개</span></a></li>
                                    <li><a href="/introduce/history"><span>연혁</span></a></li>
                                    <li><a href="/introduce/certificate"><span>인증서</span></a></li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <a href="/business/semiconductor"><span>사업영역</span></a>
                            <div className="depth__mo">
                                <ul className="">
                                    <li><a href="/business/semiconductor"><span>반도체 플랜트 배관 및 랙 제작</span></a></li>
                                    <li><a href="/business/automation"><span>자동화장비 제작</span></a></li>
                                    <li><a href="/business/mobility"><span>모빌리티 제작</span></a></li>
                                    <li><a href="/business/automatic-driving"><span>자율주행 인터페이스 제작</span></a></li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <a href="/lab/automatic-factory"><span>부설연구소</span></a>
                            <div className="depth__mo">
                                <ul className="">
                                    <li><a href="/lab/automatic-factory"><span>자동화 공장</span></a></li>
                                    <li><a href="/lab/automatic-welder"><span>자동화 용접기</span></a></li>
                                    <li><a href="/lab/automatic-driving"><span>자율주행 플랫폼</span></a></li>
                                    <li><a href="/lab/research-service"><span>연구용역</span></a></li>
                                    <li><a href="/lab/certificate"><span>인정서</span></a></li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <a href="/result/gallery"><span>사업실적</span></a>
                            <div className="depth__mo">
                                <ul className="">
                                    <li><a href="/result/gallery"><span>실적갤러리</span></a></li>
                                    <li><a href="/result/major"><span>주요실적</span></a></li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <a href="/cs/mail"><span>고객센터</span></a>
                            <div className="depth__mo">
                                <ul className="">
                                    <li><a href="/cs/mail"><span>대표메일</span></a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="gnb__wrap">
                    <div className="container-1400">
                        <ul className="gnb">
                            <li>
                                <a href="/introduce/summary"><span>회사소개</span></a>
                                <div className="depth__wrap">
                                    <ul className="depth">
                                        <li><a href="/introduce/summary"><span>회사개요</span></a></li>
                                        <li><a href="/introduce/factory"><span>공장소개</span></a></li>
                                        <li><a href="/introduce/history"><span>연혁</span></a></li>
                                        <li><a href="/introduce/certificate"><span>인증서</span></a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a href="/business/semiconductor"><span>사업영역</span></a>
                                <div className="depth__wrap">
                                    <ul className="depth">
                                        <li><a href="/business/semiconductor"><span>반도체 플랜트 배관 및 랙 제작</span></a></li>
                                        <li><a href="/business/automation"><span>자동화장비 제작</span></a></li>
                                        <li><a href="/business/mobility"><span>모빌리티 제작</span></a></li>
                                        <li><a href="/business/automatic-driving"><span>자율주행 인터페이스 제작</span></a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a href="/lab/automatic-factory"><span>부설연구소</span></a>
                                <div className="depth__wrap">
                                    <ul className="depth">
                                        <li><a href="/lab/automatic-factory"><span>자동화 공장</span></a></li>
                                        <li><a href="/lab/automatic-welder"><span>자동화 용접기</span></a></li>
                                        <li><a href="/lab/automatic-driving"><span>자율주행 플랫폼</span></a></li>
                                        <li><a href="/lab/research-service"><span>연구용역</span></a></li>
                                        <li><a href="/lab/certificate"><span>인정서</span></a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a href="/result/gallery"><span>사업실적</span></a>
                                <div className="depth__wrap">
                                    <ul className="depth">
                                        <li><a href="/result/gallery"><span>실적갤러리</span></a></li>
                                        <li><a href="/result/major"><span>주요실적</span></a></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <a href="/cs/mail"><span>고객센터</span></a>
                                <div className="depth__wrap border-right">
                                    <ul className="depth">
                                        <li><a href="/cs/mail"><span>대표메일</span></a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        </>
    );
}